"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _battery = require("@/api/iot/battery");
var _user = require("@/api/iot/user");
var _default = {
  props: ['editItem', 'roleList'],
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        id: '',
        battery_id: ''
      },
      batteryList: [],
      defaultBatteryList: [],
      rules: {
        battery_id: [{
          required: true,
          message: '请选择绑定电池',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return '绑定电池';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.getBatteryList();
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            for (var key in _this.form) {
              _this.form[key] = _this.editItem[key];
            }
          }
        });
      } else {
        this.reset();
      }
    }
  },
  mounted: function mounted() {
    this.getBatteryList();
  },
  methods: {
    reset: function reset() {
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    remoteMethod: function remoteMethod() {
      var _this2 = this;
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.$func.debounce(function () {
        // console.log('remoteMethod', query)
        if (query === '') {
          _this2.batteryList = (0, _toConsumableArray2.default)(_this2.defaultBatteryList);
        } else {
          _this2.loading = true;
          _this2.getBatteryList(query);
        }
      });
    },
    getBatteryList: function () {
      var _getBatteryList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var search,
          param,
          res,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                search = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
                param = {
                  battery_no: search,
                  battery_status: 0
                };
                if (search == '') {
                  param.pageSize = 100;
                }
                _context.next = 5;
                return (0, _battery.batteryList)(param).catch(function () {});
              case 5:
                res = _context.sent;
                // console.log('batteryList', res)
                this.loading = false;
                if (res.data) {
                  if (search == '') {
                    this.defaultBatteryList = (0, _toConsumableArray2.default)(res.data);
                    this.batteryList = (0, _toConsumableArray2.default)(this.defaultBatteryList);
                  } else {
                    this.batteryList = (0, _toConsumableArray2.default)(res.data);
                  }
                }
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getBatteryList() {
        return _getBatteryList.apply(this, arguments);
      }
      return getBatteryList;
    }(),
    submit: function submit() {
      var _this3 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          console.log('submit', _this3.form);
          (0, _user.bindBattery)(_this3.form).then(function (res) {
            console.log('bindBattery', res);
            _this3.dialogVisible = false;
            _this3.$emit('getList', true);
          });
        } else {
          _this3.$message({
            message: '请检查表单错误',
            type: 'error'
          });
          return false;
        }
      });
    }
  }
};
exports.default = _default;